"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ReduxSelectGroups;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _arrays = require("../../../utils/arrays");
var _Select = _interopRequireDefault(require("../Select"));
var _excluded = ["canDeleteInitialValue", "groupElementsIdsProp", "id", "input", "meta", "options"];
function ReduxSelectGroups(_ref) {
  var _ref$canDeleteInitial = _ref.canDeleteInitialValue,
    canDeleteInitialValue = _ref$canDeleteInitial === void 0 ? true : _ref$canDeleteInitial,
    groupElementsIdsProp = _ref.groupElementsIdsProp,
    id = _ref.id,
    input = _ref.input,
    meta = _ref.meta,
    options = _ref.options,
    other = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var value = options.reduce(function (acc, opt) {
    if (opt.value[groupElementsIdsProp].length && (0, _arrays.hasAll)(input.value, opt.value[groupElementsIdsProp])) {
      return [].concat((0, _toConsumableArray2.default)(acc), [opt.value.id]);
    }
    return acc;
  }, []);
  var newOptions = options.map(function (opt) {
    return (0, _extends2.default)({}, opt, {
      isDisabled: !opt.value[groupElementsIdsProp].length,
      value: opt.value.id
    });
  });
  var onChange = function onChange(newGroupsValue) {
    var added = (newGroupsValue == null ? void 0 : newGroupsValue.filter(function (x) {
      return !value.includes(x);
    })) || [];
    if (added.length) {
      var addedGroup = options.find(function (opt) {
        return opt.value.id === added[0];
      });
      var addedGroupElementsIds = addedGroup.value[groupElementsIdsProp];
      var newValue = input.value ? [].concat((0, _toConsumableArray2.default)(input.value.filter(function (val) {
        return !addedGroupElementsIds.includes(val);
      })), (0, _toConsumableArray2.default)(addedGroupElementsIds)) : addedGroupElementsIds;
      return input.onChange(newValue.length ? newValue : null);
    }
    var removed = value.filter(function (x) {
      return newGroupsValue && !newGroupsValue.includes(x) || false;
    });
    if (removed.length) {
      var removedGroupElementsIds = removed.reduce(function (acc, curr) {
        var removedGroup = options.find(function (opt) {
          return opt.value.id === curr;
        });
        var removedCurrElementsIds = canDeleteInitialValue || !meta.initial ? removedGroup.value[groupElementsIdsProp] : removedGroup.value[groupElementsIdsProp].filter(function (val) {
          return !meta.initial.includes(val);
        });
        return [].concat((0, _toConsumableArray2.default)(acc), (0, _toConsumableArray2.default)(removedCurrElementsIds));
      }, []);
      var _newValue = input.value.filter(function (val) {
        return !removedGroupElementsIds.includes(val);
      });
      return input.onChange(_newValue.length ? _newValue : null);
    }
    return input.onChange(null);
  };
  return /*#__PURE__*/_react.default.createElement(_Select.default, (0, _extends2.default)({
    canDeleteInitialValue: canDeleteInitialValue,
    id: id,
    input: (0, _extends2.default)({}, input, {
      onChange,
      value
    }),
    meta: (0, _extends2.default)({}, meta, {
      initial: value
    }),
    name: input.name,
    options: newOptions
  }, other));
}